export const SET_AD = 'SET_AD';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_SHOWING_SUCCESS_MESSAGE = 'SET_IS_SHOWING_SUCCESS_MESSAGE';
export const SET_ERRORS = 'SET_ERRORS';

import marketingAdRepo from '../services/marketingAd';

const setAd = ad => {
    return {
        type: SET_AD,
        ad
    }
}

const setLoading = isLoading => {
    return {
        type: SET_IS_LOADING,
        isLoading
    }
}

const setErrors = errors => {
    return {
        type: SET_ERRORS,
        errors
    }
}

export const setShowSuccessMessage = isShowingMessage => {
    return {
        type: SET_IS_SHOWING_SUCCESS_MESSAGE,
        isShowingMessage
    }
}

export const getAd = () => {
    return dispatch => {
        const success = res => {
            dispatch(setAd(res.data.data));
            dispatch(setLoading(false));
        };

        return marketingAdRepo.getAd()
            .then(success);
    }
}

export const updateAd = params => {
    return dispatch => {
        dispatch(setLoading(true));

        const success = res => {
            dispatch(setShowSuccessMessage(true));
            dispatch(setErrors({}))
            dispatch(setAd(res.data.data));
        };
        const fail = errors => {
            dispatch(setErrors(errors.data.errors))
        };

        return marketingAdRepo.updateAd(params)
            .then(success, fail)
            .finally(() => dispatch(setLoading(false)));
    }
}


// WEBPACK FOOTER //
// ./actions/marketingAd.js